import React from 'react';
import '../../Home/Home.scss';
import OwlCarousel from "react-owl-carousel2";
import "react-owl-carousel2/lib/styles.css";
import TagManager from "react-gtm-module";
import Left from "./../../../assets/images/left.svg";
import Right from "./../../../assets/images/right.svg";
import { useNavigate } from 'react-router-dom';

const videos = [
  { id: '1', youtubeId: 'GjFCqZKZkFc' },
  { id: '2', youtubeId: 'yijl6RYjj9k' },
  { id: '3', youtubeId: 'mdQwKv2dYxo' },
  { id: '4', youtubeId: 'yw50mkBsUfo' },
  { id: '5', youtubeId: 'K7x1ReOflm0' },
];

const OurVideo = () => {
  const carouselRef = React.useRef(null);
  const navigate = useNavigate();
  const options = {
    // items: ,
    nav: false,
    dots: true,
    loop: true,
    autoplay: false,
    margin: 30,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,

    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      1000: {
        items: 3,
      },
      1400: {
        items: 3,
      },
    },
  };

  const handleNextClick = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "Home Client-Speak Next Button Click",
      },
    });
    carouselRef.current.next();
  };

  const handlePrevClick = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "Home Client-Speak Previous Button Click",
      },
    });
    carouselRef.current.prev();
  };


  return (
    <section className="our-videos-section">
      <div className="container">
        <div className="our-videos-header">
          <h2 className="section-title title">Our Videos (Healthcare, AI Agents and more...)</h2>
          <button
            className="view-all-btn"
            onClick={() => window.open(
              "https://www.youtube.com/@koolmindtechnolab",
              "_blank"
            )}
            aria-label="View all videos"
          >
            View All Videos
          </button>
        </div>
        <p className="section-subtitle" >
          Experience Technology in Action, Insights Delivered Visually!
        </p>
        <div className="client_carousel">
          <button className=" nav-btn left" onClick={handlePrevClick}>
            <img src={Left} alt="prev" />
          </button>

          <OwlCarousel options={options} ref={carouselRef}>
            {videos.map((video) => (
              <div className="video-card" key={video.id}>
                <div className="video-iframe-wrapper">
                  <iframe
                    title={video?.title}
                    src={`https://www.youtube.com/embed/${video.youtubeId}`}
                    allowFullScreen
                  />
                </div>
              </div>
            ))}
          </OwlCarousel>

          <button className=" nav-btn right" onClick={handleNextClick}>
            <img src={Right} alt="next" />
          </button>
        </div>
      </div>
    </section>

  );
};

export default OurVideo;
